import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

/**
 * items: Array<{ key, label, icon?, onClick, disabled?, tooltip?, color?, hidden? }>
 */
export default function RowActionMenu({ items }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const visibleItems = items.filter((it) => !it.hidden);
  if (visibleItems.length === 0) return null;

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVert fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}>
        {visibleItems.map((it) => {
          const menuItem = (
            <MenuItem key={it.key} disabled={it.disabled}
              onClick={() => { handleClose(); it.onClick(); }}
              sx={it.color ? { color: it.color } : undefined}>
              {it.icon && (
                <ListItemIcon sx={it.color ? { color: it.color } : undefined}>{it.icon}</ListItemIcon>
              )}
              <ListItemText>{it.label}</ListItemText>
            </MenuItem>
          );
          return it.tooltip ? (
            <Tooltip key={it.key} title={it.tooltip} placement="left">
              <span>{menuItem}</span>
            </Tooltip>
          ) : menuItem;
        })}
      </Menu>
    </>
  );
}
